import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Routes, Route, useNavigate, useParams, useLocation } from 'react-router-dom';
import './App.css';
import { intro, projects } from './data';
import Player from '@vimeo/player';
// import { Player } from '@lottiefiles/react-lottie-player';

function importAll(r) {
  let images = {};
  r.keys().forEach((item) => {
    images[item.replace('./', '')] = r(item);
  });
  return images;
}

const images = importAll(
  require.context('./images', true, /\.(png|jpe?g|svg|gif)$/)
);

function Intro({ language }) {
  const introText = intro[language];

  return (
    <p>
      <a href="https://punkt.kr" target="_blank" rel="noreferrer noopener" className="intro-link">
        {introText.main}<sup className="intro-superscript">{introText.sub}</sup>
      </a>
      {introText.text}
      <a href="https://pikant.kr" target="_blank" rel="noreferrer noopener" className="intro-link-pikant">
        {introText.studio}<sup className="intro-superscript">{introText.studioSub}</sup>
      </a>
      {introText.suffix}
    </p>
  );
}

function App() {
  // const [selectedProject, setSelectedProject] = useState(null);
  const location = useLocation();
  const [language, setLanguage] = useState('ko');
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
const navigate = useNavigate();

const handleClick = (project) => {
  navigate(`/project/${project.id}`);
  setIsSidebarOpen(false);
};


  const toggleLanguage = () => {
    setLanguage(language === 'ko' ? 'en' : 'ko');
  };

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className="app-container">
      <div className="header-container">
        <button onClick={toggleSidebar} className="sidebar-toggle-btn">
          {isSidebarOpen ? 'Close' : 'Menu'}
        </button>
        <div className="header-title">
          <h1><a href="http://punkt.kr" rel="noopener noreferrer">punkt.</a></h1>
        </div>
        <button onClick={toggleLanguage} className="language-toggle">
          {language === 'ko' ? 'EN' : 'KO'}
        </button>
      </div>
      <div className={`main-container ${isSidebarOpen ? 'sidebar-open' : ''}`}>
        <div className={`sidebar ${isSidebarOpen ? 'open' : ''}`}>
          <div className="intro">
            <Intro language={language} />
          </div>
          <div className="project-list">
            {projects.map(project => (
              <div
                key={project.id}
                className={`project-link ${
  location.pathname === `/project/${project.id}` ? 'active' : ''
}`}

                onClick={() => handleClick(project)}
              >
                {project.name[language]}
              </div>
            ))}
          </div>
        </div>
   <div className="content">
  <Routes>
    <Route
      path="/"
      element={
        <RandomThumbnails
          projects={projects}
          setSelectedProject={(p) => navigate(`/project/${p.id}`)}
          language={language}
        />
      }
    />
    <Route
      path="/project/:id"
      element={<ProjectRoute projects={projects} language={language} />}
    />
  </Routes>
</div>
      </div>
    </div>
  );
}

function ProjectRoute({ projects, language }) {
  const { id } = useParams();
  const project = projects.find(p => String(p.id) === id);

  if (!project) return null;

  return <ProjectDetail project={project} language={language} />;
}

function RandomThumbnails({ projects, setSelectedProject, language }) {

  useEffect(() => {
  const setVh = () => {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  };

  setVh();
  window.addEventListener('resize', setVh);
  window.addEventListener('orientationchange', setVh);

  return () => {
    window.removeEventListener('resize', setVh);
    window.removeEventListener('orientationchange', setVh);
  };
}, []);
  const isMobile = window.matchMedia('(max-width: 768px)').matches;
const containerWidth = window.innerWidth;
const thumbnailWidth = isMobile ? 120 : 160; // 실제 썸네일 크기에 맞게 조정
const sideMargin = isMobile ? 16 : 0;        // 좌우 여백
  const shuffledProjects = [...projects].sort(() => 0.5 - Math.random());
  const positions = [];

  const itemGap = isMobile ? 180 : 0; // 썸네일 간 최소 세로 간격(px)
  const thumbnailCount = projects.length;
const containerHeightPx = isMobile
  ? thumbnailCount * itemGap + 200
  : window.innerHeight;

  const getRandomPosition = (index) => {
  let x, y, tooClose;
  const threshold = isMobile ? 22 : 15; // 모바일은 간격 넓게

const mobileColumns = isMobile
  ? [
      sideMargin + thumbnailWidth * 0.6,                 // 왼쪽
      containerWidth / 2,                                 // 가운데
      containerWidth - sideMargin - thumbnailWidth * 0.6 // 오른쪽
    ]
  : [];

  // 모바일/데스크탑 y 범위 설정
  const yRange = isMobile ? 170 : 75;
  const yOffset = isMobile ? 10 : 15;

  // 썸네일 높이 고려한 하단 안전 마진 (%)
  const bottomSafeMargin = isMobile ? 15 : 8;

  let guard = 0; // 무한 루프 방지

  do {
    tooClose = false;

if (isMobile) {
  const baseX =
    mobileColumns[Math.floor(Math.random() * mobileColumns.length)];

  const randomOffset = (Math.random() - 0.5) * 40; // 좌우 흔들림
  x = baseX + randomOffset;
} else {
  x = Math.random() * 75 + 15;
}

  if (isMobile) {
    // 모바일: 무조건 아래로 쌓이되, 좌우만 랜덤
    y = index * itemGap + Math.random() * 40;
  } else {
    // 데스크탑: 기존 랜덤 유지
    y = Math.random() * 75 + 15;
  }


    // 🔒 하단 잘림 방지
    // y = Math.min(y, yRange + yOffset - bottomSafeMargin);

    for (const pos of positions) {
      const dx = x - pos.x;
      const dy = y - pos.y;
      const distance = Math.sqrt(dx * dx + dy * dy);

      if (distance < threshold) {
        tooClose = true;
        break;
      }
    }

    guard++;
    if (guard > 50) break; // 배치가 빡셀 때 강제 탈출
  } while (tooClose);

  positions.push({ x, y });
  return { x, y };
};


  const handleMouseEnter = (event) => {
    event.currentTarget.style.zIndex = 100;
  };

  const handleMouseLeave = (event) => {
    event.currentTarget.style.zIndex = 1;
  };

  return (
<div
  className="thumbnails"
  style={{
    position: 'relative',
    height: isMobile
      ? `${containerHeightPx}px`
      : '100vh'
  }}
>
      {shuffledProjects.map((project, index) => {
  const { x, y } = getRandomPosition(index);
        return (
          <div
            key={project.id}
            onClick={() => setSelectedProject(project)}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
           style={{
        position: 'absolute',
         left: isMobile ? `${x}px` : `${x}%`,
        top: isMobile ? `${y}px` : `${y}%`,
        transform: isMobile
          ? 'translate(-50%, 0)'      // 모바일: 상단 기준
          : 'translate(-50%, -50%)'   // 데스크탑: 중심 기준
      }}
          >
            <img src={images[project.thumbnail]} alt={project.name[language]} className="thumbnail" />
          </div>
        );
      })}
    </div>
  );
}


function ProjectDetail({ project, language }) {
  const renderMedia = (media) => {
    switch (media.type) {
      case 'image':
        return (
          <div key={media.src} className="project-image-container">
            <img src={images[media.src]} alt={`Project ${project.name[language]}`} className="project-image" />
            {media.caption && <div className="image-caption">{media.caption[language]}</div>}
          </div>
        );
      case 'lottie':
        return (
          <div key={media.src} className="lottie-container">
            <iframe src={media.src} width="100%" height="100%" frameBorder="0" allow="autoplay; fullscreen" title="Lottie Animation"></iframe>
          </div>
        );
      case 'vimeo':
        return (
          <div key={media.src} className="video-container">
            <iframe
              src={media.src}
              width="100%"
              height="100%"
              frameBorder="0"
              allow="autoplay; fullscreen; picture-in-picture"
              allowFullScreen
              title="Vimeo Video"
            ></iframe>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="project-container">
      <h2 className="project-title">{project.name[language]}</h2>
      <div className="project-description">
        <div className={`project-text ${language === 'en' ? 'en' : ''}`}>
          <p>{project.text[language]}</p>
        </div>
        <div className="project-detail">
          <table className="project-table">
          <tbody>
  {Object.keys(project.details).map((key, index) => (
    <tr
      key={index}
      className={key === 'Design' ? 'design-row' : ''}
    >
      <td className="table-category">{key}</td>
      <td className="table-content">
        {key === 'Design' ? (
          project.details.Design.people.map((person, idx) => (
            <span key={idx}>
              <a
                className="project-content-link"
                href={person.url}
                target="_blank"
                rel="noopener noreferrer"
              >
                {person.name[language]}
              </a>
              {idx < project.details.Design.people.length - 1 && ', '}
            </span>
          ))
        ) : key === 'Link' ? (
          <a
            className="project-content-link"
            href={project.details[key].url}
            target="_blank"
            rel="noopener noreferrer"
          >
            {project.details[key].content[language]}
          </a>
        ) : (
          project.details[key][language]
        )}
      </td>
    </tr>
  ))}
</tbody>
          </table>
        </div>
      </div>
      <div className="project-media">
        {project.images.map(media => renderMedia(media))}
      </div>
    </div>
  );
}





export default App;
